<template>
  <div class="lyear-layout-web">
    <div class="lyear-layout-container">
      <!--左侧导航-->
      <user-left></user-left>
      <!--End 左侧导航-->
      
      <!--头部信息-->
      <user-head></user-head>
      <!--End 头部信息-->
      
      <!--页面主要内容-->
      <main class="lyear-layout-content">
        
        <div class="container-fluid">
          
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-toolbar clearfix">
                  <!-- <form class="pull-right search-bar"> -->
                  <div class="pull-right search-bar">
                    <div class="input-group">
                      <div class="input-group-btn">
                        <button class="btn btn-default dropdown-toggle" id="search-btn" data-toggle="dropdown" type="button" aria-haspopup="true" aria-expanded="false">
                        标题 <!-- <span class="caret"></span> -->
                        </button>
                        <ul class="dropdown-menu">
                          <li> <a tabindex="-1" href="javascript:void(0)" data-field="title">标题</a> </li>
                          <!-- <li> <a tabindex="-1" href="javascript:void(0)" data-field="cat_name">栏目</a> </li> -->
                        </ul>
                      </div>
                      <input type="text" class="form-control" v-model="topic" @keyup.enter="downrecord(0)" placeholder="请输入名称">
                    </div>
                  </div>
                  <!-- </form> -->
                  <div class="toolbar-btn-action">
                    <!-- <a class="btn btn-primary m-r-5" href="#!"><i class="mdi mdi-plus"></i> 全部订单</a>
                    <a class="btn btn-success m-r-5" href="#!"><i class="mdi mdi-check"></i> 已支付订单</a>
                    <a class="btn btn-warning m-r-5" href="#!"><i class="mdi mdi-block-helper"></i>未支付订单</a> -->
                    <div class="btn btn-danger" @click="delete1 = true" ><i class="mdi mdi-window-close"></i> 删除</div>
                  </div>
                </div>
                <div class="card-body">
                  
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>
                            <!-- <label class="lyear-checkbox checkbox-primary">
                              <input type="checkbox" :checked="ischeck" @change="changeCheck(item.id)"><span></span>
                            </label> -->
                          </th>
                          <th>编号</th>
                          <th>预览</th>
                          <th>名称</th>
                          <th>类型</th>
                          <th>状态</th>
                          <th>投稿时间</th>
                          <th>操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item,index in downList" :key="index">
                          <td>
                            <label class="lyear-checkbox checkbox-primary" v-if="item.SYS_CURRENTSTATUS=='已退稿' || item.SYS_CURRENTSTATUS=='已删除'" >
                              <input type="checkbox" :checked="ischeck" @change="changeCheck(item.SYS_DOCLIBID + '_' + item.SYS_DOCUMENTID,item.SYS_CURRENTSTATUS)"><span></span>
                            </label>
                          </td>
                          <td>{{index+1}}</td>
													<td>
														<viewer :images="[item.coverUrl.cover]" >
															<img
																	v-for="(src,index) in [item.coverUrl.cover]"
																	:src="src"
																	:key="index"
																	class="priviewImg shou"
																>
														</viewer>
													</td>
                          <td>{{item.SYS_TOPIC}}</td>
                          <td>{{item.DOC_TYPE == 1?'单图':'组图'}}</td>
                          <!-- <td>金庸</td> -->
                          <td>{{item.SYS_CURRENTSTATUS=='已删除'?'已退稿':item.SYS_CURRENTSTATUS}}</td>
													<td>{{item.SYS_CREATED}}</td>
													<td>
                            <div class="flex-c" style="height: 80px;">
                              <div class="btn btn-xs btn-default" v-if="item.SYS_CURRENTSTATUS=='已退稿'  || item.SYS_CURRENTSTATUS=='已删除'"  @click="editTg(item.SYS_DOCLIBID + '_' + item.SYS_DOCUMENTID)"><i class="mdi mdi-pencil"></i></div>
                              <div class="btn btn-xs btn-default" v-if="item.SYS_CURRENTSTATUS=='已退稿'  || item.SYS_CURRENTSTATUS=='已删除'" @click="collectDel(item.SYS_DOCLIBID + '_' + item.SYS_DOCUMENTID,item.SYS_CURRENTSTATUS)" ><i class="mdi mdi-window-close"></i></div>
															<div class="btn btn-xs btn-default" v-if="item.SYS_CURRENTSTATUS!='已退稿'  && item.SYS_CURRENTSTATUS!='已删除'"  @click="lookTg(item.SYS_DOCLIBID + '_' + item.SYS_DOCUMENTID)"><i class="iconfont iconchakan"></i></div>
														</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
       
									<!-- 分页器 -->
									<div class="pagination">
										<Page class-name="page-class" :total="total" :page-size="6" @on-change="changePage" />
									</div>
									         
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
        
      </main>
      <!--End 页面主要内容-->
    </div>
		
		<Modal
				v-model="delete1"
				title="友情提示"
				@on-ok="collectDel"
				@on-cancel="">
				<p>是否确认删除选中的收藏列表</p>
		</Modal>
  </div>
</template>

<script>
import userLeft from './user_left.vue'
import userHead from './user_head.vue'
export default {
  data () {
    return {
			downList: [],
			total: 0,
			delId: [],
			ischeck: false,
			delete1: false,
			topic: ''
		}
  },
	
	components: {
		userLeft,
		userHead
	},
	
  created () {},
	
	mounted () {
		this.downrecord()
	},

  methods: {
		// 我的投稿
		async downrecord (page=0) {
			let _this = this
			_this.$Spin.show()
			let data = {
				loginName: localStorage.getItem('loginName'),
				size: 6,
				page,
				topic: _this.topic,
			}
			const res = await _this.post_res('/devote/getList.do', data)
			res.data.content.forEach(x => x.SYS_CREATED = _this.util.formatDate(x.SYS_CREATED))
			_this.downList = res.data.content
			_this.total = res.data.total - 0
			_this.$Spin.hide()
		},
		
		// 页码改变
		changePage (page) {
			this.downrecord(page-1)
		},
		
		// 单选框选中与不选中
		changeCheck (id,state) {
			// console.log(id)
			let _this = this
			if (state != '已退稿') {
				_this.ischeck = false
				return _this.util.showMsg('warning','当前状态不可删除稿件',3,false)
			}
			if (_this.delId.includes(id)) {
				let index = _this.delId.findIndex(x =>  x==id)
				_this.delId.splice(index,1)
			} else {
				_this.delId.push(id)
			}
		},
		
		// 批量删除收藏
		async collectDel (id = 0,state) {
			let _this = this
			if (id) {
				if (state != '已退稿') {
					return _this.util.showMsg('warning','当前状态不可删除稿件',3,false)
				}
				const res = await _this.delete_api('/devote/delDevote.do?ids=' + id)
				if (res.status == 0) {
					_this.ischeck = false
					_this.util.showMsg('success', res.message, 3,false)
				} else {
					_this.ischeck = false
					_this.util.showMsg('warning', res.message, 3,false)
				}
				// _this.ischeck = false
				// _this.$Message.success({
				// 	content: '删除成功'
				// })
			} else {
				if (!_this.delId.length) {
					return _this.$Message.error({
						content: '请选择相应的投稿'
					})
				}
				const res = await _this.delete_api('/devote/delDevote.do?ids=' + _this.delId)
				if (res.status == 0) {
					_this.ischeck = false
					_this.util.showMsg('success', res.message, 3,false)
				} else {
					_this.ischeck = false
					_this.util.showMsg('warning', res.message, 3,false)
				}
			}
			
			window.location.reload()
		},
		
		editTg (id) {
			this.$router.push({path: '/userCbt',query:{id}})
		},
		lookTg (id) {
			this.$router.push({path: '/userCbtlook',query:{id}})
		}
		
	}
}
</script>

<style lang="less" scoped>
.priviewImg {
	max-width: 100px;
	max-height: 80px;
	vertical-align: middle;
}
td,th {text-align: center;line-height: 80px!important;}
</style>
